(() => {
  if (window.__ovilixaLinkedColorsReady) return;
  window.__ovilixaLinkedColorsReady = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ov-linked-color]');
    if (!link) return;
    if (link.matches('[aria-current="true"]')) {
      event.preventDefault();
      return;
    }

    const variantSelects = link.closest('variant-selects');
    if (!variantSelects) return;
    const sizeInput = variantSelects.querySelector('input[data-option-name="Size"]:checked');
    const sizeSelect = variantSelects.querySelector('select[name^="options[Size]"]');
    const selectedSize = sizeInput?.value || sizeSelect?.value;
    if (!selectedSize) return;

    try {
      const urls = JSON.parse(link.dataset.ovSizeUrls || '{}');
      if (!urls[selectedSize]) return;
      event.preventDefault();
      const targetUrl = new URL(urls[selectedSize], window.location.origin);
      const productInfo = link.closest('product-info');
      if (!productInfo) {
        window.location.assign(targetUrl.href);
        return;
      }

      const currentProductPath = new URL(productInfo.dataset.url, window.location.origin).pathname;
      if (targetUrl.pathname === currentProductPath) {
        const color = link.dataset.color;
        const nativeColorInput = Array.from(
          variantSelects.querySelectorAll('[data-option-name="Color"]')
        ).find((input) => input.value === color);

        if (nativeColorInput) {
          if (nativeColorInput.tagName === 'OPTION') {
            const select = nativeColorInput.closest('select');
            select.value = nativeColorInput.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            nativeColorInput.click();
          }
          return;
        }
      }

      link.classList.add('is-loading');
      productInfo.setAttribute('aria-busy', 'true');
      productInfo.abortController?.abort();
      productInfo.abortController = new AbortController();

      fetch(targetUrl.href, { signal: productInfo.abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(`Linked colour request failed (${response.status}).`);
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          if (!html.querySelector("product-info[id^='MainProduct']")) {
            throw new Error('Linked colour product markup is missing.');
          }
          productInfo.handleSwapProduct(targetUrl.pathname, true)(html);
          window.setTimeout(() => {
            document.querySelector(`[data-ov-linked-color][data-color="${CSS.escape(link.dataset.color)}"]`)?.focus();
          }, 50);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') window.location.assign(targetUrl.href);
        })
        .finally(() => {
          link.classList.remove('is-loading');
          productInfo.removeAttribute('aria-busy');
        });
    } catch (_error) {
      // The normal href remains a complete, accessible fallback.
    }
  });
})();
